<div class="row delete-confirm">
  <div class="col-sm-12 mb-3">
    Your current session is about to expire in next 10 seconds. 
    Would you like to continue with the session? <br />
    <span class="text-info"></span>
  </div>
  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-5">
        <button
          type="button"
          (click)="Reset()"
          class="btn btn-sm btn-primary me-3"
        >
          Yes
        </button>

        <button
          type="button"
          (click)="Logout()"
          class="btn btn-sm btn-secondary"
        >
          No
        </button>
      </div>
    </div>
  </div>
</div>
